import { render } from "./Mb019.vue?vue&type=template&id=51045777"
import script from "./Mb019.vue?vue&type=script&lang=js"
export * from "./Mb019.vue?vue&type=script&lang=js"

import "./Mb019.vue?vue&type=style&index=0&id=51045777&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__